/* eslint-disable react/no-string-refs */
import { h, Component } from 'preact';
import style from './style';
import cx from 'classnames';
import Icon from '../icon';
import ClickOutsideDetector from '../click-outside-detector';
import SafeAnchor from '../safe-anchor';
import linkRef from 'linkref';

export default class Popover extends Component {
	state = { active: this.props.active || false }

	/**
	 * After closing the Popover, if props.focusAfterClosing is truthy, re-focus the Popover button
	 */
	focusAfterToggle = () => {
		!this.state.active && this.props.focusAfterClosing && this.refs.button.focus();
	}

	/**
	 * Open or close the Popover
	 */
	togglePopover = () => {
		const active = !this.state.active;

		this.setState({ active }, this.focusAfterToggle);
		this.props.onToggle && this.props.onToggle(active);
	};

	componentWillReceiveProps({ active }) {
		typeof active === 'boolean' && this.props.active !== active && this.setState({ active }, this.focusAfterToggle);
	}

	render({ children, classes = {}, popoverClass, toggleClass, titleClass, containerClass, icon, iconPosition, text, anchor, href, ...props }, { active }) {
		delete props.onToggle;
		delete props.active;

		// Rather than support 4 props for classes, just use one classes object:
		classes = { popoverClass, toggleClass, titleClass, containerClass, ...classes };

		icon = typeof icon === 'string' ? <Icon class={style.icon} name={icon} /> : icon;
		return (
			<ClickOutsideDetector onClickOutside={active && this.togglePopover}>
				<div {...props} class={cx(style['popover-container'], classes.containerClass, props.class)}>
					<SafeAnchor
						href={href}
						aria-haspopup={'true'}
						aria-expanded={String(Boolean(active))}
						class={cx(classes.toggleClass, style.button)}
						onClick={this.togglePopover}
						ref={linkRef(this, 'button')}
					>
						{iconPosition === 'left' && icon}
						<span class={cx(style.title, classes.titleClass)}>{text}</span>
						{iconPosition === 'right' && icon}
					</SafeAnchor>
					{children && children.length && (
						<div class={cx(style.popover, style[anchor], classes.popoverClass, active && style.active)}>
							{children}
						</div>
					)}
				</div>
			</ClickOutsideDetector>
		);
	}
}

